/**
 * Formata a situação da parcela para exibição legível
 * Ex: 'A' => 'Aberto', 'F' => 'Fechado'
 * @param value - Código da situação
 * @returns Descrição legível da situação
 */
export const parcelaSituacaoFormat = (value: string): string => {
  if (!value) return '-';

  const situacaoMap: Record<string, string> = {
    'A': 'Não Quitado',
    'C': 'Cancelado',
    'Q': 'Quitado',
  };

  return situacaoMap[value] || value;
};
